import React, { Component } from 'react';
import { connect } from "react-redux";
//import store from '../store/configureStore'
import PropTypes from 'prop-types';

class Cart extends Component{
  constructor(props){
    super(props)
    this.state = {
      count : 0,
    }
  }

  render(){
    return (
      <div>
          <span className='badge badge-warning' id='lblCartCount'> {this.props.count} </span>
          <i className="fa fa-shopping-cart fa-4x " aria-hidden="true"></i>
      </div>
    )
  }
}
Cart.propTypes={
count:PropTypes.number,
//navigateHome:PropTypes.string,
}
Cart.defaultProps= {
count:1,
//navigateHome:[],
}

const mapStateToProps = (state) => {
    return {
        count : state.cartItems.count
    }
}
// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }
export default connect(mapStateToProps)(Cart);
